import { Button, ButtonProps } from '@mui/material';

export const PrimaryButton = Button;

export const FormSubmitButton = (props: ButtonProps) => (
    <PrimaryButton type="submit" {...props} />
);
